import Axios from 'axios';
import store from '@/store';
import { getToken } from '@/services/authentication';
import router from '@/router';
import { getTimeZone } from '@/helpers/utils';

Axios.interceptors.request.use(
  function (config) {
    store.dispatch('loading/startLoading');

    const token = getToken();

    if (token) config.headers.Authorization = `Bearer ${token}`;

    const { ID_PORTAL } = store.getters['authentication/getConfig'];
    const portal = store.getters['dev/getSelectedPortal'];

    config.headers.timeZone = getTimeZone();
    config.headers.id_portal = ID_PORTAL;
    if (portal)
      config.headers.idPortalDev = portal.portalId;

    return config;
  },

  function (error) {
    Promise.resolve(error).then(function ({ response }) {
      let message = '';

      if (response.data instanceof Array) {
        response.data.map(item => (message += `${item.message} \n`));
      } else {
        message = response.data.message;
      }

      return store.dispatch('notification/showNotification', {
        color: 'error',
        text: message,
        showIconNotification: false
      });
    });

    store.dispatch('loading/finishLoading');
  }
);

Axios.interceptors.response.use(
  function (response) {
    store.dispatch('loading/finishLoading');

    return response;
  },

  function (error) {
    let responseError = error;

    Promise.resolve(error).then(function ({ response }) {
      if (!response) {
        store.dispatch('notification/showNotification', {
          color: 'error',
          text: responseError.Message || responseError.message || 'Internal Server Error',
          showIconNotification: false
        });

        return;
      }

      switch (response.status) {
        case 400: {
          let message = '';

          if (response.data instanceof Array) response.data.map(item => (message += `${item.message} \n`));
          else message = response.data.message;

          store.dispatch('notification/showNotification', {
            color: 'error',
            text: message,
            showIconNotification: false
          });

          break;
        }

        case 401: {
          localStorage.removeItem(store.getters['authentication/getConfig'].VUE_APP_TOKEN_KEY);

          store.dispatch('notification/showNotification', {
            color: 'error',
            text: 'Sua sessão expirou. Faça seu login novamente.',
            showIconNotification: false
          });

          router.push({ path: '/login' });

          break;
        }

        case 403: {
          router.push({ path: '/403' });
          break;
        }

        case 404: {
          router.push({ path: '/404' });
          break;
        }

        case 415:
        case 502:
        case 503: {
          store.dispatch('notification/showNotification', {
            color: 'error',
            text: response.statusText,
            showIconNotification: false
          });

          break;
        }

        case 500: {
          store.dispatch('errors/showError500', {
            color: 'error',
            error: response.data,
            status: 500
          });

          break;
        }

        default: {
          store.dispatch('notification/showNotification', {
            color: 'error',
            text: response.data.message,
            showIconNotification: false
          });
        }
      }
    });

    store.dispatch('loading/finishLoading');
  }
);
